import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../guard';
// Import new functional resolvers (Angular 14+ API)
import {
  dashboardResolver,
  projectResolver,
  scenarioFormResolver,
  scenarioResolver,
  scenarioViewResolver,
} from '@resolver';
import {
  DashboardComponent,
  DashboardModule,
  ProjectComponent,
  ProjectModule,
  ScenarioComponent,
  ScenarioFormComponent,
  ScenarioFormModule,
  ScenarioModule,
} from '@view';

enum Routing {
  doc = 'doc',
  list = 'list',
  configured = 'configured',
  history = 'history',
  root = '',
  viewProject = 'details/:projectId/view-project',
  createScenario = 'details/:projectId/create-scenario',
  viewScenario = 'details/:scenarioId/view-scenario',
  editScenario = 'details/:scenarioId/edit-scenario',
}

const routerOptions: ExtraOptions = {
  onSameUrlNavigation: 'reload',
  enableTracing: false,
};

const routes: Routes = [
  {
    path: Routing.root,
    component: DashboardComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    resolve: { updates: dashboardResolver },
  },
  {
    path: Routing.viewProject,
    component: ProjectComponent,
    canActivate: [AuthGuard],
    resolve: { project: projectResolver },
  },
  {
    path: Routing.createScenario,
    component: ScenarioFormComponent,
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    canActivate: [AuthGuard],
    resolve: { scenario: scenarioResolver, scenarioForm: scenarioFormResolver },
  },
  {
    path: Routing.viewScenario,
    component: ScenarioComponent,
    canActivate: [AuthGuard],
    resolve: { scenario: scenarioResolver, scenarioView: scenarioViewResolver },
  },
  {
    path: Routing.editScenario,
    component: ScenarioFormComponent,
    canActivate: [AuthGuard],
    resolve: { scenario: scenarioResolver, scenarioForm: scenarioFormResolver, scenarioView: scenarioViewResolver },
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    DashboardModule,
    ProjectModule,
    RouterModule.forRoot(routes, routerOptions),
    ScenarioModule,
    ScenarioFormModule,
  ],
  exports: [RouterModule],
  providers: [
    AuthGuard,
    // Note: Functional resolvers (ResolveFn) don't need to be provided here
    // They use inject() to get dependencies directly
  ],
})
export class CoreRoutingModule {}
